import axios from 'axios';
import backendUrl from '../backendUrl';
import { setConfig } from './auth';

const baseUrl = `${backendUrl}/sites`;

const createNote = async (
  siteId: string,
  concentrateurId: string,
  noteBody: string
) => {
  const response = await axios.post(
    `${baseUrl}/${siteId}/concentrateurs/${concentrateurId}/notes`,
    { body: noteBody },
    setConfig()
  );
  return response.data;
};

const editNote = async (
  siteId: string,
  noteId: number,
  noteBody: string
) => {
  const response = await axios.put(
    `${baseUrl}/${siteId}/notes/${noteId}`,
    { body: noteBody },
    setConfig()
  );
  return response.data;
};

const deleteNote = async (siteId: string, noteId: number) => {
  const response = await axios.delete(
    `${baseUrl}/${siteId}/notes/${noteId}`,
    setConfig()
  );
  return response.data;
};

const noteService = {
  createNote,
  editNote,
  deleteNote,
};

export default noteService;
